import { LoggedUserInfo } from 'common/support-chat/utils';
import { SupportChatConfig } from 'common/support-chat/getSupportChatConfig';
import { ChatSourceType } from 'src/tracking-container/events/chat';
import { tokenProviders } from 'common/support-chat/tokens';
import { getTrackingByEventName } from 'src/tracking-container/TrackingEvents';
import { OneChatApp } from './index.d';

export const SUPPORT_CHAT_WIDGET_ID = 'support-chat-widget';
export const SUPPORT_CHAT_GLOBAL = 'OneChatApp';

let chatWidget: OneChatApp;
const trackEvent = getTrackingByEventName('chat_opened');

export function onSupportChatOpen(
  userInfo: LoggedUserInfo,
  conf: SupportChatConfig,
  el: HTMLElement,
) {
  return async ({ source }: { source: ChatSourceType }) => {
    trackEvent({ service: 'Salesforce', source });
    try {
      await loadScript(conf.bootstrapJsSrc);
    } catch (err) {
      handleError(
        err,
        'Error loading custom chat script',
        true,
        'Failed to load the chat, please try again later.',
      );
      return;
    }
    try {
      if (!window[SUPPORT_CHAT_GLOBAL]) {
        throw new Error('Script loaded but chat object not found in window scope.');
      }
      conf.init.rootElementId = el.id;
      if (!chatWidget) {
        chatWidget = window.OneChatApp({
          ...conf.init,
          userInfo: {
            ...userInfo,
            source: 'Web',
          },
          getAccessToken: tokenProviders.getAccessToken,
          getProfileAccessToken: tokenProviders.getProfileAccessToken,
        });
        await chatWidget.init();
      }
      chatWidget.open();
    } catch (err) {
      handleError(
        err,
        'Error initializing the chat',
        true,
        'Failed to launch the chat, please try again later.',
      );
    }
  };
}

const loadScript = (src: string, id = 'support-chat-widget-script'): Promise<void> => {
  if (window[SUPPORT_CHAT_GLOBAL] !== undefined) {
    return Promise.resolve();
  }

  // Remove stale script tag from a previous incomplete/failed load attempt
  document.querySelector(`script[id="${id}"]`)?.remove();

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.async = true;
    script.id = id;
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', (ev: ErrorEvent) => reject(ev));
    document.head.appendChild(script);
  });
};

const handleError = (
  error: unknown,
  message: string,
  showNotification: boolean,
  userMessage?: string,
) => {
  console.error(`[custom-support-chat] ${message}`, error);
  if (showNotification) {
    Wahanda.ToastNotifications.sendMessage(userMessage, {
      variant: 'danger',
      timeout: 2500,
    });
  }
};
